import Main from "./component.main";
import store from "./script.store";
const Player = { Main, store };
export default Player;
